module.exports = __webpack_public_path__ + "img/product-atomizer-sopuria-EilbarPro.e6b52b76.jpg";